import React, { useEffect, useState } from 'react'
import IconButtonWrapper from 'views/pages/manage/common/form-fields-mui/IconButtonWrapper';
import { useHistory } from 'react-router-dom';
import { getDropdowns, normalizeToArray, SEARCH_SLAB_FORM_FIELDS, searchPaymentSlab } from './constants';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { Card } from "reactstrap";
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import { useSelector } from "react-redux";
import { dropdownMapping, fetchAllPostPromisedData, fetchAllPromisedData, getDropdownLabelsFromSelectArray, updateRequest } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod"
import ListComponent from "./ListComponent";
import { ReactComponent as BackIcon } from "assets/img/svg/BackArrow.svg";
import { checkPermission } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';

const ExamPayRate = ({ userPermissions }) => {

    const history = useHistory();
    const [slabRows, setSlabRows] = useState([]);
    const [form, setForm] = useState({ ...SEARCH_SLAB_FORM_FIELDS });
    const [dropdowns, setDropdowns] = useState([]);
    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 0,
        totalPage: 0,
        totalRecords: 0,
    });
    const [currPageSize, setCurrentPageSize] = useState(50);
    const [isLoading, setIsLoading] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const isCreatePermission = checkPermission(userPermissions, "C");
    const isUpdatePermission = checkPermission(userPermissions, 'U');

    const masterDropdowns = useSelector(
        (state) => state.globalData.masterDropdowns,
    );

    const [buOptions, setBuOptions] = useState(masterDropdowns?.businessArea || [])

    const filterBuForState = (buOptions, state) => {
        const stateList = (state || []).map(item => String(item?.value));

        const businessArea = (masterDropdowns?.businessArea || []).filter(item =>
            stateList.includes(item?.stateCode)
        );

        setBuOptions(businessArea.map((item) => ({
            ...item, label: item.label,
            value: item.businessAreaId,
        })));
    };


    const handleForm = (key, value) => {
        setForm((prev) => ({ ...prev, [key]: value }));
    };


    const init = async () => {
        try {
            setIsLoading(true);
            const res = await getDropdowns();
            setDropdowns(res);
        } catch (err) {
            console.log(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        init();
    }, []);


    const searchHandler = async (pageNumber = 0, pageSize = currPageSize) => {
        try {
            setIsLoading(true);
            setHasSearched(true); // mark that search happened

            const req = updateRequest({ ...form });
            const { state, country, bu } = req;

            const payload = {
                stateIds: normalizeToArray(state),
                businessUnitIds: normalizeToArray(bu),
                countryIds: normalizeToArray(country),
                slabType: "INVIGILATOR"
            };

            const resp = await searchPaymentSlab(payload, pageNumber, pageSize);

            if (resp?.code === 200) {
                const rowsWithSrNo = (resp?.data?.data || []).map((item, index) => ({
                    ...item,
                    srNo: pageNumber * pageSize + index + 1,
                }));

                setSlabRows(rowsWithSrNo);
                setCurrentPageSize(pageSize);
                setPaginationInfo({
                    currentPage: resp?.data?.currentPage,
                    totalPage: resp?.data?.totalPage,
                    totalRecords: resp?.data?.totalRecords,
                });
            }
        }
        catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);
        }
    }

    const isFormValid =
        (form.state && form.state.length > 0) ||
        (form.bu && form.bu.length > 0) ||
        (form.country && form.country.length > 0);

    const nextButtonHandler = (newPage, currPageSize) => {
        searchHandler(newPage, currPageSize);
    };
    const handleReset = () => {
        setForm({ ...SEARCH_SLAB_FORM_FIELDS });
        setSlabRows([]);
        setPaginationInfo({
            currentPage: 0,
            totalPage: 0,
            totalRecords: 0,
        });
        setHasSearched(false); //  reset visibility
    }

    return (
        <div className="d-flex flex-column p-4" style={{ width: "100%" }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center">
                    <IconButtonWrapper onClick={() => window.history.back()}>
                        <BackIcon />
                    </IconButtonWrapper>
                    <h2 className="color-black-60 text-bold mb-0 ml-2">
                        Exam pay rate master
                    </h2>
                </div>
                {(isCreatePermission || isUpdatePermission) && <AButton
                    variant="primary_filled"
                    onClick={() => history.push("/admin/invigilatorPayrateSlab/new")}
                >
                    Add a new slab
                </AButton>
                }
            </div>

            <Card className="p-4">
                <h2 className="mb-2 text-bold">Search a slab</h2>
                <div
                    style={{
                        width: "70%",
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr) auto",
                        gap: "15px",
                    }}
                >
                    <AAutoComplete
                        label="Country"
                        placeholder="Select"
                        isMulti={true}
                        isShowCount
                        items={dropdowns?.country}
                        currentValue={form?.country}
                        handleChange={(value) => handleForm("country", value)}
                        height="45px"
                    />

                    <AAutoComplete
                        label="State"
                        placeholder="Select"
                        isMulti={true}
                        isShowCount
                        items={dropdowns?.state}
                        currentValue={form?.state}
                        handleChange={(value) => {
                            handleForm("state", value)
                            handleForm("bu", "")
                            filterBuForState(buOptions, value)
                        }}
                        height="45px"
                    />

                    <AAutoComplete
                        label="BU"
                        placeholder="Select"
                        isMulti={true}
                        isShowCount
                        items={buOptions}
                        currentValue={form?.bu}
                        handleChange={(value) => handleForm("bu", value)}
                        isDisabled={!form?.state}
                        height="45px"
                    />

                    <AButton
                        variant="primary_filled"
                        disabled={!isFormValid || isLoading}
                        onClick={() => searchHandler(0, currPageSize)}
                        className="mt-auto"
                    >
                        Search slab
                    </AButton>

                    {isFormValid && (
                        <AButton
                            variant="outline_danger"
                            onClick={handleReset}
                            className="mt-auto"
                        >
                            Reset
                        </AButton>
                    )}
                </div>
            </Card>

            {hasSearched && (
                <ListComponent
                    currentPage={paginationInfo?.currentPage}
                    currPageSize={currPageSize}
                    rows={slabRows}
                    isLoading={isLoading}
                    rowCount={paginationInfo.totalRecords}
                    nextButtonHandler={nextButtonHandler}
                />
            )}


        </div >
    )
}

export default ExamPayRate;